import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

import { faMapLocation } from "@fortawesome/pro-solid-svg-icons";
import Popover from "antd/es/popover";
import { useIntl } from "react-intl";

import { isMacOS } from "@mapmycustomers/shared/util/browser";

import { ToolButton } from "@app/component/map/FeaturedMap";
import { setLocationSearchVisibility } from "@app/scene/map/store/actions";
import { isLocationSearchVisible } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";

import GoToLocationPopover from "../../GoToLocationPopover";
import GoToLocationPulse from "../../MapMode/components/GoToLocationPulse";

interface Props {
  isLocationSearchVisible: boolean;
  onSetLocationSearchVisibility: typeof setLocationSearchVisibility;
}

const GoToLocationToolButton: React.FC<Props> = ({
  isLocationSearchVisible,
  onSetLocationSearchVisibility,
}) => {
  const intl = useIntl();
  const [lookUpLocation, setLookUpLocation] = useState<google.maps.LatLngLiteral | undefined>();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleOpenChange = useCallback(
    (newOpen: boolean) => {
      onSetLocationSearchVisibility(newOpen);
      setShowTooltip(false);
    },
    [onSetLocationSearchVisibility, setShowTooltip]
  );

  return (
    <Popover
      content={<GoToLocationPopover setLookUpLocation={setLookUpLocation} />}
      destroyTooltipOnHide
      onOpenChange={handleOpenChange}
      open={isLocationSearchVisible}
      placement="leftBottom"
      trigger="click"
    >
      <ToolButton
        active={isLocationSearchVisible}
        icon={faMapLocation}
        title={`${intl.formatMessage({
          id: "map.control.goToLocation",
          defaultMessage: "Go to location",
          description: "Go to location button tooltip",
        })} ${isMacOS() ? "⇧⌘L" : "Ctrl+Shift+L"}`}
        tooltipProps={{
          onOpenChange: setShowTooltip,
          open: isLocationSearchVisible ? false : showTooltip,
        }}
      />
      <GoToLocationPulse lookUpLocation={lookUpLocation} />
    </Popover>
  );
};

const mapStateToProps = (state: RootState) => ({
  isLocationSearchVisible: isLocationSearchVisible(state),
});

const mapDispatchToProps = {
  onSetLocationSearchVisibility: setLocationSearchVisibility,
};

export default connect(mapStateToProps, mapDispatchToProps)(GoToLocationToolButton);
